<template>
  <v-app>
    <v-app-bar
      app
      extended
      elevation="0"
      extension-height="50"
      hide-on-scroll
      class="test_blue"
      scroll-target="#scrolling-menu"
    >
      <div class="px-2">
        <Logo is-admin />
      </div>
      <v-spacer />
      <div class="px-2">
        <v-btn icon @click="handleFullScreen()">
          <v-icon large v-text="'mdi-fullscreen'" />
        </v-btn>
      </div>

      <div class="px-2">
        <Language />
      </div>
      <div class="px-2">
        <profile />
      </div>

      <template v-slot:extension>
        <TabMenuAccount />
      </template>
    </v-app-bar>
    <v-main id="scrolling-menu" class="test_purple">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import { Profile, TabMenuAccount } from "./components";
import { toggleFullScreen } from "@/utils/full-screen";
export default {
  layout: "Admin",
  middleware: "admin",
  name: "Account",
  components: {
    Profile,
    TabMenuAccount,
  },
  methods: {
    handleFullScreen() {
      toggleFullScreen();
    },
  },
};
</script>
<style scoped>
.background_template {
  background-color: #f2f3f8;
  height: 100vh;
}
</style>
